import React from 'react';
import { Query } from '@apollo/react-components';
import { gql } from '@apollo/client';
import numeral from 'numeral';
import Well from '$components/ProductDashboard/Well';
import SpinnerError from '$components/library/SpinnerError';
import styles from './styles.scss';

const EXAM_READINESS = gql`
  query ExamReadiness($input: ExamReadinessInput!) {
    examReadiness(input: $input) {
      readiness
    }
  }
`;

const getFlavor = (readiness) => {
  if (readiness === 1) {
    return {
      flavorText: "You're ready for the exam, let us know how it goes!",
      flavorIcon: 'fad fa-file-certificate',
    };
  }

  if (readiness > 0.9) {
    return {
      flavorText: 'Build a buffer against exam stress and unlucky questions! ',
      flavorIcon: 'fad fa-shield-check',
    };
  }

  if (readiness > 0.8) {
    return {
      flavorText: "You're close to the target!",
      flavorIcon: 'fad fa-bullseye-arrow',
    };
  }

  if (readiness > 0.7) {
    return {
      flavorText: "You're heating up!",
      flavorIcon: 'fad fa-fire',
    };
  }

  if (readiness > 0.6) {
    return {
      flavorText: 'Keep that energy going! ',
      flavorIcon: 'fad fa-transformer-bolt',
    };
  }

  if (readiness > 0.5) {
    return {
      flavorText: "You're over halfway there, keep doing your best! ",
      flavorIcon: 'fad fa-hand-sparkles',
    };
  }

  if (readiness > 0.4) {
    return {
      flavorText: "You're on the path to success! ",
      flavorIcon: 'fad fa-person-hiking',
    };
  }

  if (readiness > 0.3) {
    return {
      flavorText: 'Keep building your knowledge!',
      flavorIcon: 'fad fa-screwdriver-wrench',
    };
  }

  if (readiness > 0.2) {
    return {
      flavorText: 'Keep your focus up!',
      flavorIcon: 'fad fa-mug-saucer',
    };
  }

  if (readiness > 0.1) {
    return {
      flavorText: "You're getting into the groove!",
      flavorIcon: 'fad fa-boombox',
    };
  }

  if (readiness > 0) {
    return {
      flavorText: 'Time to get your learn on!',
      flavorIcon: 'fad fa-book-open-cover',
    };
  }

  return {
    flavorText: "It's only up from here!",
    flavorIcon: 'fad fa-rocket-launch',
  };
};

const ExamReadiness = (props) => {
  const { productSlug, productUuid } = props;

  return (
    <div className={styles.layout}>
      <Query
        query={EXAM_READINESS}
        variables={{ input: { productSlug, productUuid } }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data }) => {
          if (loading || error) {
            return (
              <div className={styles.spinnerContainer}>
                <SpinnerError error={error} />
              </div>
            );
          }

          const {
            examReadiness: { readiness },
          } = data;

          const readinessPercent = numeral(readiness).format('0%');
          const { flavorText, flavorIcon } = getFlavor(readiness);

          return (
            <div className={styles.layoutInner}>
              <div className={styles.examReadiness}>
                Exam readiness:{' '}
                <div className={styles.percentage}>{readinessPercent}</div>
              </div>
              <div className={styles.flavorText}>
                {flavorText} <i className={flavorIcon} />
              </div>
            </div>
          );
        }}
      </Query>
    </div>
  );
};

export default ExamReadiness;
